<template>
  <v-dialog
    persistent
    :value="internalIsDisplay"
    width="unset"
    :maxWidth="maxWidth"
  >
    <v-card>
      <div class="content content-pad">
        <v-col
          class="content-col"
          cols="11"
        >
          <div class="header-img">
            <v-img
              :src="imgsrc('icons', imgUrl)"
              width="12rem"
            />
          </div>
          <div class="header-title">
            {{ $t(title) }}
          </div>
          <div class="content-desc">
            {{ $t(description) }}
          </div>
          <div class="footer-actions d-flex flex-column align-center">
            <slot>
              <v-btn
                text
                class="theme-btn app-button-primary color nice-padding"
                @click="internalIsDisplay = false"
              >
                {{ $t('common.action.acknowledge') }}
              </v-btn>
            </slot>
          </div>
        </v-col>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
  import mixinDynImage from '@/mixins/utils/dynImage.js'

  export default {
    mixins: [mixinDynImage,],
    props: {
      isDisplay: {
        type: Boolean,
        required: true,
      },
      title: {
        type: String,
        default: null,
      },
      description: {
        type: String,
        default: null,
      },
      imgUrl: {
        type: String,
        default: null,
      },
      maxWidth: {
        type: [String, Number,],
        default: null,
      },
    },
    data() {
      return {
        dialogIntern: false,
      }
    },
    computed: {
      internalIsDisplay: {
        get() {
          return this.isDisplay
        },
        set(value) {
          return this.$emit('update:isDisplay', value)
        },
      },
    },
  }
</script>

<style scoped lang="scss">
.content,
.content-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .header-title {
    margin-top: 1.5rem;
    font-size: 1.5rem;
    font-weight: 500;
    color: $color-001c4b;
    text-align: center;
    letter-spacing: 0;
    line-height: 2rem;
  }
  .content-desc {
    margin-top: 0.8rem;
    text-align: center;
    font-size: 1rem;
    font-weight: 500;
    color: $color-4d4d4f;
    margin-bottom: 1.5rem;
  }
}
.content-pad {
  padding: 2.5rem;
}
.v-card.v-sheet {
  border-radius: 8px;
  background-color: $color-ffffff;
  box-shadow: 0 7px 64px 0 rgba(0, 0, 0, 0.07) !important;
}
</style>
